export class NotificationHandlerService {
    handlers = new Map();
    addHandler(topic, handler) {
        const notificationHandlers = this.handlers.get(topic) || [];
        if (notificationHandlers.includes(handler)) {
            return () => undefined;
        }
        notificationHandlers.push(handler);
        this.handlers.set(topic, notificationHandlers);
        return () => {
            this.removeHandler(topic, handler);
        };
    }
    removeHandler(topic, handler) {
        const notificationHandlers = this.handlers.get(topic);
        if (notificationHandlers) {
            const index = notificationHandlers.indexOf(handler);
            if (index !== -1) {
                notificationHandlers.splice(index, 1);
            }
        }
    }
    handleNotification(notification) {
        const { topic } = notification;
        const notificationHandlers = this.handlers.get(topic) || [];
        for (const handler of notificationHandlers) {
            void handler(notification);
        }
    }
    hasHandlers(topic) {
        const notificationHandlers = this.handlers.get(topic);
        return !!notificationHandlers && notificationHandlers.length > 0;
    }
}
//# sourceMappingURL=notification-handler-service.js.map